import api from '.';

export const ncmById = async (id) => {
    try {
        const { data } = await api.get(`/ncm/retornaNCMById/${id}`);
        return data;
    } catch (error) {
        return error;
    }
};
export const retornaNCMByCodigo = async (codigo) => {
    try {
        const { data } = await api.get(`/ncm/retornaNCMByCodigo/${codigo}`);
        return data;
    } catch (error) {
        return error;
    }
};
